<template>
  <van-dropdown-item :title="tit" ref="item">
    <van-cell title="全选">
      <template #right-icon>
          <van-checkbox name="all" @click="toggleAll"  v-model="checkedAll"/>
        </template>
    </van-cell>
    <van-checkbox-group v-model="selectedList" ref="checkboxGroup">
      <van-cell-group>
        <van-cell center :title="item[option.label]" v-for="(item, index) in columns" :key="item[option.value]" @click="toggle(index)">
          <template #right-icon>
            <van-checkbox :name="item[option.value]" ref="checkboxes"></van-checkbox>
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
    <div class="search-bottom">
      <span class="btncancel" @click="cancelType">重置</span>
      <span class="btnconfirm" @click="comfirm">确定</span>
    </div>
  </van-dropdown-item>
</template>

<script>
export default {
  name: 'VanDropdownCheckbox',
  props: {
    title: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectValue: {
      type: Array,
      default: function () {
        return []
      }
    },
    option: {
      type: Object,
      default: function () {
        return { label: 'text', value: 'value' }
      }
    },
  },
  computed: {
  },
  data() {
    return {
      checkedAll: false,
      selectedList: JSON.parse(JSON.stringify(this.selectValue)),
      tit: JSON.parse(JSON.stringify(this.title)),
    }
  },
  mounted() {
    this.setTitle()
  },
  methods: {
    cancelType() {
      this.tit = JSON.parse(JSON.stringify(this.title))
      this.checkedAll = false
      this.selectedList = []
    },
    comfirm() {
      this.$refs.item.toggle()
      let resultValue = this.selectedList.join(',')
      this.setTitle()
      this.$emit('comfirm', resultValue)
    },
    toggleAll(all) {
      this.$refs.checkboxGroup.toggleAll(this.checkedAll)
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    // 根据选择项修改标题
    setTitle() {
      if (this.selectedList.length == 1) {
        for (let i = 0; i < this.columns.length; i++) {
          const col = this.columns[i];
          if (col.value == this.selectedList.join(',')) {
            this.tit = col.text
          }
        }
      } else if (this.selectedList.length > 1) {
        this.tit = `${this.title}（${this.selectedList.length}）`
      } else if (this.selectedList.length < 1) {
        this.tit = JSON.parse(JSON.stringify(this.title))
      }
    }
  },
  watch: {
    selectedList: {
      handler (val) {
        this.setTitle()
        if (val.length && val.length === this.columns.length) {
          this.checkedAll = true
        } else {
          this.checkedAll = false
        }
      },
      immediate: true
    },
    selectValue: {
      handler (val) {
         this.selectedList = JSON.parse(JSON.stringify(val))
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.search-bottom {
    height: 0.5rem;
    width: 100%;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.11rem;
    .btnconfirm {
      width: 1.72rem;
      height: 0.39rem;
      background: #1890ff;
      border-radius: 0.03rem;
      text-align: center;
      line-height: 0.39rem;
      color: #fff;
    }
    .btncancel {
      width: 1.72rem;
      height: 0.39rem;
      background: #f6f6f6;
      border: 0.01px solid rgba(25, 31, 37, 0.12);
      border-radius: 0.03rem;
      text-align: center;
      line-height: 0.39rem;
    }
  }
  .label {
      margin-left: -0.03rem;
      margin-top: -0.1rem;
      span {
        height: 0.16rem;
        background: #f0f6fe;
        color: #1890ff;
        margin-right: 0.1rem;
        padding: 0.03rem 0.08rem;
        font-size: 0.11rem;
        border-radius: 0.03rem;
      }
    }
</style>

